import React from 'react';
import ReactDOM from 'react-dom';

import { AuthModalProps } from '../types/auth';

import '../styles/auth.css';

import { AuthModalWrapper } from './AuthModalWrapper';

export const AuthModal: React.FC<AuthModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <AuthModalWrapper isOpen={isOpen} onClose={onClose} />,
    document.body
  );
};
